React = require 'react/addons'
AgeStore = require '../stores/age-store'
AgeVerification = require '../actions/age-verification'
Router = require 'react-router'
Reflux = require 'reflux'
AgeGateVideoStore = require '../stores/age-gate-video-store'
VideoStore = require '../stores/video-store'
VideoPlayer = require './shared/video-player'
MediaQuery = require '../mixins/media-query'
LightMode = require '../mixins/light-mode'
redirectTo = 'http://responsibility.org/underage-drinking'

module.exports = React.createClass
  displayName: 'AgeGate'

  mixins: [MediaQuery, Reflux.listenTo(AgeStore, 'onStatusChange'), Router.Navigation, LightMode]

  onStatusChange: (status) ->
    if status.ageVerification is 'true'
      @transitionTo '/'
    else if status.ageVerification is 'false'
      document.location.href = redirectTo

  validateAge: (event) ->
    event.preventDefault()
    AgeVerification.ageVerification {valid: 'true'}

  invalidateAge: (event) ->
    event.preventDefault()
    AgeVerification.ageVerification {valid: 'false'}

  render: ->
    index = Math.floor(Math.random() * ((AgeGateVideoStore.videos.length - 1) + 1))
    videoDef = AgeGateVideoStore.videos[index]

    video = null
    for vid, j in VideoStore.videos when vid.key is videoDef.video
      video = vid
      break

    videoPlayer = if @state.isMobile then (React.createElement("span", null)) else (React.createElement(VideoPlayer, {"key": (video.name), "video": (video)}))

    logoFormat = if Modernizr.svg then '.svg' else '.png'

    prefix = CDN_URL

    React.createElement("div", {"ref": 'ageGate', "className": 'age-gate'},
      (videoPlayer),
      React.createElement("h1", null,
        React.createElement("img", {"className": 'logo-image', "src": ("#{prefix}/img/logo-age-gate#{logoFormat}"), "alt": 'Santera Tequila'}),
        React.createElement("img", {"className": 'dark-logo-image', "src": ("#{prefix}/img/logo-age-gate-dark#{logoFormat}"), "alt": 'Santera Tequila'})
      ),
      React.createElement("div", {"className": 'disclaimer'},
        React.createElement("p", null, "ARE YOU OF LEGAL DRINKING AGE"),
        React.createElement("div", {"className": 'buttons'},
          React.createElement("a", {"href": '#', "onClick": (@validateAge)}, "Yes"), " | ", React.createElement("a", {"href": '#', "onClick": (@invalidateAge)}, "No")
        )
      )
    )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/age-gate.cjsx
 **/